import { buttonFocus } from "shared/styles/mixins"
import styled from "styled-components"

import { ButtonProps } from "./types"

export const BaseButton = styled.button.attrs((props) => ({
  type: props.type || "button",
}))<ButtonProps>`
  appearance: none;
  background-color: transparent;
  border: none;
  font-weight: 600;
  color: ${(props) => props.theme.colors.dark};
  font-size: ${(props) => props.theme.button.textSize};
  white-space: nowrap;
  line-height: normal;
  position: relative;
  overflow: hidden;
  text-align: center;
  transition: all 50ms ease-in;
  user-select: none;

  text-transform: uppercase;
  font-family: ${(props) => props.theme.font.display};

  // this unseen border-radius and padding affects focus styles.
  padding: 5px 15px;
  border-radius: ${(props) => props.theme.button.borderRadius};

  &:disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }

  ${buttonFocus}
`
